import PropTypes from 'prop-types';
import { fromGlobalId } from 'graphql-relay';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import classnames from 'classnames';
import moment from 'moment';
import R from 'ramda';

import Cell from '../Cell';
import Button from '../Button';

import styles from './course-list-item.css';

const { p, span, div, h2 } = hh(h);

const CourseListItem = ({ course }) => {
    const date = `${moment(new Date(course.startDate)).format('MMM Do')}—${moment(new Date(course.endDate)).format('Do YYYY')}`;
    const nameStyles = classnames(styles.name, R.prop(R.prop('type', course), styles));

    const beginnerElement = div({className: styles.levelContainer}, [
        span({className: styles.levelIntro}, 'Level'),
        span({className: styles.filledCircle}),
        span({className: styles.emptyCircle}),
        span({className: styles.emptyCircle})
    ]);

    const intermediateElement = div({className: styles.levelContainer}, [
        span({className: styles.levelIntro}, 'Level'),
        span({className: styles.filledCircle}),
        span({className: styles.filledCircle}),
        span({className: styles.emptyCircle})
    ]);

    const advancedElement = div({className: styles.levelContainer}, [
        span({className: styles.levelIntro}, 'Level'),
        span({className: styles.filledCircle}),
        span({className: styles.filledCircle}),
        span({className: styles.filledCircle})
    ]);

    const levelElement = {
        beginner: beginnerElement,
        intermediate: intermediateElement,
        advanced: advancedElement
    };

    const links = {
        html: '/html-and-css',
        js: '/javascript'
    };

    const partialDateElement = R.partial(p, [{className: styles.date}]);

    const courseId = fromGlobalId(course.id).id;

    const detailsLink = h(Button, {
        href: R.prop(course.type, links),
        query: { course: courseId },
        fill: true,
        classList: [styles.button]
    }, ['Details']);

    const applyLink = h(Button, {
        href: `course/${courseId}`,
        disabled: R.equals(course.state, 'closed'),
        fill: true,
        classList: [styles.button]
    }, ['Apply']);

    const linkContainer = div({className: styles.linkContainer}, [
        detailsLink,
        applyLink
    ]);

    return (
        h(Cell, {className: styles.cell}, [
            div({className: styles.container}, [
                !R.prop('tbd', course) ? partialDateElement(date) : partialDateElement('TBD'),
                h2({className: nameStyles}, course.name),
                p({className: styles.university}, course.university.name),
                R.prop(course.level, levelElement),
                p({className: styles.description}, course.description),
                linkContainer])])
    );
};

CourseListItem.propTypes = {
    course: PropTypes.object.isRequired
};

export default CourseListItem;



/** WEBPACK FOOTER **
 ** ./src/CourseListItem/index.js
 **/